// DXF Cart Display v2.2.0 - JavaScript version
// Include this in your theme to display DXF information in cart and checkout

(function() {
  'use strict';
  
  console.log('DXF Cart Display v2.2.0 loaded');
  
  // Remove any legacy rows the old override may have injected
  function removeLegacyPriceRows(scopeEl) {
    if (!scopeEl) return;
    const KEYS = ['price_override', 'calculated_price', 'unit_price', 'total_price'];

    // Remove common theme structures: definition lists (dt + dd) or generic rows
    // 1) DT/DD pairs with key labels
    const dts = scopeEl.querySelectorAll('dt, .product-option');
    dts.forEach((dt) => {
      const label = (dt.textContent || '').trim().toLowerCase().replace(/:$/, '');
      if (KEYS.includes(label)) {
        // Remove matching dd sibling if present
        const dd = dt.nextElementSibling;
        if (dd && dd.tagName && /^(DD|DIV|SPAN)$/i.test(dd.tagName)) {
          dd.remove();
        }
        dt.remove();
      }
    });

    // 2) Any stray elements that contain the keys
    const blacklist = new RegExp(`\\b(${KEYS.join('|')})\\b`, 'i');
    scopeEl.querySelectorAll('*').forEach((el) => {
      if (typeof el.textContent === 'string' && blacklist.test(el.textContent)) {
        el.remove();
      }
    });
  }

  function findLeftDetailsContainer(cartItem) {
    // Prefer the details/description area, never totals
    return (
      cartItem.querySelector('.cart-item__details') ||
      cartItem.querySelector('.cart-item__name') ||
      cartItem.querySelector('.cart__item-title') ||
      cartItem.querySelector('.cart-item__title') ||
      cartItem
    );
  }

  // Function to display DXF information for cart items
  function displayDxfInfo() {
    // Find all cart items
    const cartItems = document.querySelectorAll('.cart-item, .cart__item, [data-cart-item]');
    
    cartItems.forEach((cartItem, index) => {
      // Always clean legacy rows first
      removeLegacyPriceRows(cartItem);
      // Skip if DXF info is already displayed
      if (cartItem.querySelector('.dxf-item-details')) {
        return;
      }
      
      // Get cart data to find DXF properties
      fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          const cartItemData = cartData.items[index];
          
          if (cartItemData && cartItemData.properties) {
            const properties = cartItemData.properties;
            
            // Check if this is a DXF item
            if (properties.Filename || properties.Material || properties.Units) {
              // If we have a filename, surface it in the visible title
              const titleEl = cartItem.querySelector('.cart-item__name, .cart-item__title, .cart__item-title, a.cart-item__name, a.cart__item-name');
              if (titleEl && properties.Filename) {
                const baseTitle = (titleEl.getAttribute('data-base-title') || titleEl.textContent || 'Item').split(' — ')[0].trim();
                titleEl.setAttribute('data-base-title', baseTitle);
                titleEl.textContent = `${baseTitle} — ${properties.Filename}`;
              }

              // Remove the separate filename display since it's already in the title
              // const dxfDetails = createDxfDetailsElement({ Filename: properties.Filename });
              // const container = findLeftDetailsContainer(cartItem);
              // if (container) {
              //   // Ensure this appears under the title/description region
              //   const title = container.querySelector('.cart-item__title, .cart-item__name, .cart__item-title');
              //   if (title && title.parentNode) {
              //     title.parentNode.insertBefore(dxfDetails, title.nextSibling);
              //   } else {
              //     container.appendChild(dxfDetails);
              //   }
              // }
              // Ensure nothing is injected into totals/right column
              cartItem.querySelectorAll('.cart-item__totals .dxf-item-details, .cart__item--totals .dxf-item-details').forEach(n => n.remove());
            }
          }
        })
        .catch(error => {
          console.error('Error fetching cart data for DXF display:', error);
        });
    });
  }
  
  // Function to create DXF details element
  function createDxfDetailsElement(properties) {
    const dxfDetails = document.createElement('div');
    dxfDetails.className = 'dxf-item-details';
    dxfDetails.style.cssText = `
      margin-top: 8px;
      padding: 8px;
      background: #f8f9fa;
      border-radius: 4px;
      font-size: 0.85em;
      border-left: 3px solid #007bff;
    `;
    
    let detailsHTML = '';
    
    if (properties.Filename) {
      detailsHTML += `<div style="margin-bottom: 3px;"><strong>File:</strong> ${properties.Filename}</div>`;
    }
    // Do not render material/dimensions/units to avoid duplicates with theme output
    
    // Intentionally do not render any raw pricing fields from properties
    
    dxfDetails.innerHTML = detailsHTML;
    return dxfDetails;
  }
  
  // Function to display DXF info in checkout
  function displayDxfInfoInCheckout() {
    // Check if we're on checkout page
    if (window.location.pathname.includes('/checkout')) {
      // Get cart data
      fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          // Find checkout line items
          const checkoutItems = document.querySelectorAll('.product__description, .product__title, [data-product-title]');
          
          checkoutItems.forEach((item, index) => {
            // Clean legacy rows around each checkout item as well
            removeLegacyPriceRows(item?.parentNode || document);
            const cartItem = cartData.items[index];
            
            if (cartItem && cartItem.properties) {
              const properties = cartItem.properties;
              
              // Check if this is a DXF item
              if (properties.Filename || properties.Material || properties.Units) {
                // Skip if DXF info is already displayed
                if (item.parentNode.querySelector('.dxf-item-details')) {
                  return;
                }
                
                // Remove filename display since it's already in the title
                // const dxfDetails = createDxfDetailsElement(properties);
                // 
                // // Insert after the product description
                // item.parentNode.insertBefore(dxfDetails, item.nextSibling);
              }
            }
          });
        })
        .catch(error => {
          console.error('Error fetching cart data for checkout DXF display:', error);
        });
    }
  }
  
  // Helper to format money consistently
  function formatMoney(amount) {
    const n = Number(amount || 0);
    return `$${n.toFixed(2)}`;
  }

  // Replace visual prices in cart for DXF items and subtotal (UI only; no backend price change)
  async function updateVisualPrices() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const cartItemsEls = Array.from(document.querySelectorAll('.cart-item, .cart__item, [data-cart-item]'));

      let computedSubtotal = 0;

      cart.items.forEach((item, idx) => {
        const container = cartItemsEls[idx];
        if (!container) return;

        const qty = Number(item.quantity || 1);
        const isDxf = item.properties && item.properties._calculated_price;

        if (isDxf) {
          const unit = Number(item.properties._calculated_price);
          const line = unit * qty;
          computedSubtotal += line;

          // Update per-line unit price and totals inside this item
          const priceCandidates = container.querySelectorAll('.cart-item__price, .cart-item__price-wrapper, .price, .price--end, .cart-item__totals [class*="price"], .cart-item__totals [class*="total"], [data-cart-item-price]');
          priceCandidates.forEach(el => {
            // Limit to nodes that currently display a currency
            if (el && typeof el.textContent === 'string' && /\$/i.test(el.textContent)) {
              // Decide if this element is unit or line total using heuristics
              if (/total/i.test(el.className) || /line|total/i.test(el.parentElement?.className || '')) {
                el.textContent = formatMoney(line);
              } else {
                el.textContent = formatMoney(unit);
              }

              // Hide adjacent base Shopify price (compare-at or unit price) if present
              const neighbors = [el.previousElementSibling, el.nextElementSibling];
              neighbors.forEach(n => {
                if (!n) return;
                const txt = (n.textContent || '').trim();
                if (/^\$\s*\d/.test(txt) || /unit price|regular price|compare-at/i.test(txt)) {
                  n.textContent = '';
                }
              });
            }
          });
        } else {
          // Non-DXF: use Shopify line price
          const lineCents = Number(item.final_line_price || item.line_price || 0);
          computedSubtotal += lineCents / 100;
        }
      });

      // Update subtotal/estimated total display (both Dawn and similar themes)
      const subtotalEls = document.querySelectorAll('.totals__subtotal-value, .cart__footer .totals__subtotal-value, .cart__footer .totals .price, .cart__blocks .totals__subtotal-value, [data-checkout-subtotal-price-target], .cart__ctas .totals__subtotal-value, .cart__footer .price, .cart__footer [class*="subtotal"], .cart__footer [class*="total"], .cart__blocks .price, .cart__blocks [class*="subtotal"], .cart__blocks [class*="total"]');
      subtotalEls.forEach(el => {
        if (el && typeof el.textContent === 'string' && /\$/i.test(el.textContent)) {
          el.textContent = formatMoney(computedSubtotal);
        }
      });
      
      // Also try to find any element that contains "Estimated total" or "Subtotal"
      const totalTextEls = document.querySelectorAll('*');
      totalTextEls.forEach(el => {
        if (el && typeof el.textContent === 'string' && 
            (el.textContent.includes('Estimated total') || el.textContent.includes('Subtotal')) &&
            /\$\s*\d/.test(el.textContent)) {
          // Replace the price part while keeping the label
          el.textContent = el.textContent.replace(/\$\s*[\d,]+\.?\d*/, formatMoney(computedSubtotal));
        }
      });

      console.log('[DXF] Visual subtotal updated:', formatMoney(computedSubtotal));
    } catch (e) {
      console.warn('[DXF] Failed to update visual prices:', e);
    }
  }

  // Initialize DXF display
  function initDxfDisplay() {
    // Display DXF info on page load
    displayDxfInfo();
    displayDxfInfoInCheckout();
    updateVisualPrices();

    // Viewer runtime overrides so changes apply even if extension bundle is cached
    // Keep minimal, idempotent overrides to avoid performance issues
    function applyViewerOverrides(root) {
      try {
        const scope = root || document;
        // Helper to compute and render total on the Add to Cart button
        const syncCartButtonTotal = () => {
          const unitEl = scope.querySelector('#calculated-price');
          const qtyEl = scope.querySelector('#quantity-display');
          const priceSpan = scope.querySelector('#cart-price');
          const unit = unitEl ? Number(unitEl.textContent || 0) : 0;
          const qty = qtyEl ? Number(qtyEl.textContent || 1) : 1;
          if (priceSpan) {
            priceSpan.textContent = (unit * qty).toFixed(2);
            priceSpan.style.color = 'inherit';
            priceSpan.style.fontWeight = 'inherit';
          }
        };
        // Force default unit to inches
        const unitSel = scope.querySelector('#unit-select');
        if (unitSel && unitSel.value !== 'in') {
          unitSel.value = 'in';
          unitSel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // Ensure add-to-cart price inherits button styles
        const priceSpan = scope.querySelector('#cart-price');
        if (priceSpan) {
          priceSpan.style.color = 'inherit';
          priceSpan.style.fontWeight = 'inherit';
        }
        // Keep button showing TOTAL (unit * qty)
        syncCartButtonTotal();
        // Update visible viewer header version text
        const header = scope.querySelector('h4');
        if (header && /Fastest DXF Viewer/i.test(header.textContent || '')) {
          if (!/v2.1.6/.test(header.textContent)) {
                                header.textContent = 'Fastest DXF Viewer (v2.1.9)';
          }
        }

        // Observe quantity or unit price changes to re-sync total on the button
        const watchNodes = [
          scope.querySelector('#quantity-display'),
          scope.querySelector('#calculated-price'),
          scope.querySelector('#add-to-cart-btn')
        ].filter(Boolean);
        watchNodes.forEach((node) => {
          if (!node || node.dataset.dxfWatch === '1') return;
          node.dataset.dxfWatch = '1';
          const mo = new MutationObserver(() => syncCartButtonTotal());
          mo.observe(node, { childList: true });
        });
        // Also hook into plus/minus clicks for fast updates without observers
        const plus = scope.querySelector('#quantity-plus');
        const minus = scope.querySelector('#quantity-minus');
        [plus, minus].forEach(btn => {
          if (!btn || btn.dataset.dxfWatch === '1') return;
          btn.dataset.dxfWatch = '1';
          btn.addEventListener('click', () => setTimeout(syncCartButtonTotal, 0));
        });
      } catch (e) {}
    }

    // Apply once and observe for dynamic inserts
    // Try now; if container isn't present yet, watch body briefly until it appears
    const attachToContainer = (container) => {
      if (!container) return;
      if (container.dataset.dxfWired === '1') return;
      container.dataset.dxfWired = '1';
      applyViewerOverrides(container);
      let scheduled = false;
      const viewerObserver = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          applyViewerOverrides(container);
        });
      });
      viewerObserver.observe(container, { childList: true, subtree: true });
    };

    let container = document.getElementById('dxf-uploader-app-block');
    if (container) {
      attachToContainer(container);
    } else {
      const bodyObserver = new MutationObserver(() => {
        container = document.getElementById('dxf-uploader-app-block');
        if (container) {
          attachToContainer(container);
          bodyObserver.disconnect();
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
    
    // Listen for cart updates
    document.addEventListener('cart:updated', function() {
      setTimeout(() => { displayDxfInfo(); updateVisualPrices(); }, 500); // Wait for cart to update
    });
    
    // Listen for checkout page changes
    if (window.location.pathname.includes('/checkout')) {
      // Check for dynamic content changes
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            setTimeout(displayDxfInfoInCheckout, 100);
          }
        });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDxfDisplay);
  } else {
    initDxfDisplay();
  }
  
                  console.log('DXF Cart Display v2.2.0 initialized');
  console.log('Features: filename display, visual price override for DXF lines (base price hidden)');
})();

